const name = {
  SET_USER_INFO: 'SET_USER_INFO',
  SET_NEWS_COUNT: 'SET_NEWS_COUNT',
  SET_TASK_INFO: 'SET_TASK_INFO',
  Set_Head_Action: 'Set_Head_Action',
  Set_Left_Action: 'Set_Left_Action',
  Set_Behavior_Body_Add: 'Set_Behavior_Body_Add',
  Set_Behavior_Body_Del: 'Set_Behavior_Body_Del',
};

export default name;
